import React from 'react';
import './../zone.css';
import emiImg from '../ZonetablePoster/EMI.png';
import kailashImg from '../ZonetablePoster/Kailash.png';
import mirrorImg from '../ZonetablePoster/Mirror.png';
import museumImg from '../ZonetablePoster/Museum.png';
import heartImg from '../ZonetablePoster/Heart.png';

function ZoneTable({ onBack }) {
 const sequenceTableData = [
  {
    picture: heartImg,
    title: "When Hearts Whisper Again",
    genre: "Romance • Self-Discovery • Faith • Family • Sufi-inspired Reflection",
    zone1: "The Argument",
    zone2: "The Voice of Khidr",
    zone3: "The Reflection Test (Zone 34 Fusion)",
    zone4: "The Reunion in the Wish Zone",
    zone5: "Soul Dimensions: A Journey Beyond Love",
  
  },
  {
    picture: museumImg,
    title: "A Museum Love Story",
    genre: "Romance • Self-Discovery • Faith • Family",
    zone1: "Museum Mayhem The Button Nobody Should Press",
    zone2: "The Clone Wars Will the Real Master Please Stand Up",
    zone3: "The Temptation Maze Who Do You Want to Be",
    zone4: "The Wish Rift Write Carefully… It Might Come True",
    zone5: "The Hall of Truth Final Soul Test",
  
  },
  {
    picture: emiImg,
    title: "EMI-e-motion The Great Indian Reset",
    genre: "Comedy • Drama • Family • Self-Realization",
    zone1: "The Bench of Broken Hearts",
    zone2: "Home is the First Pilgrimage",
    zone3: "Chaos and Coexistence",
    zone4: "Seva and Surrender",
    zone5: "Kailash is Within",
    
  },
   {
    picture: kailashImg,
    title: "The Last Bus to Kailash",
    genre: "Emotional Drama • Spiritual Journey • Comedy of Realization Format",
    zone1: "The Breakdown Before Entry",
    zone2: "Welcome to the Dysfunction Zone",
    zone3: "Memory Playback The Parents Edition",
    zone4: "Wish Swap & Soul Mirror",
    zone5: "Emily's Haunting Redemption_ A Multi-Fai",
   
  },
   {
    picture: mirrorImg,
    title: "THE MIRROR OF ERIS — Possessed or Awakened",
    genre: "Horror | Psychological Thriller | Multi-faith Redemption Drama",
    zone1: "Museum Entry – The Peace She Didn’t Expect",
    zone2: "The Whispering Library",
    zone3: "Game of Delusions",
    zone4: "Wish Room of Truth",
    zone5: "Final Scene Hall of Happy Chaos",
  },
];

  const thStyle = {
    border: '1px solid white',
    padding: '8px',
    textAlign: 'center'
  };

  const tdStyle = {
    border: '1px solid white',
    padding: '8px',
    textAlign: 'center'
  };

  return (
    <div style={{ backgroundColor: 'black', minHeight: '100vh', padding: '20px' }}>
      <h1 className="zone-title">Sequence Table</h1>
      <table className="zone-table" style={{ width: '100%', borderCollapse: 'collapse', color: 'white' }}>
      <thead>
      <tr>
        <th className="th-picture">Picture</th>
        <th className="th-title">Title</th>
        <th className="th-genre">Genre</th>
        <th className="th-zone">Zone 1</th>
        <th className="th-zone">Zone 2</th>
        <th className="th-zone">Zone 3</th>
        <th className="th-zone">Zone 4</th>
        <th className="th-zone">Zone 5</th>
      </tr>
    </thead>

        <tbody>
          {sequenceTableData.map((item, index) => (
            <tr key={index}>
              <td style={tdStyle}>
                <img src={item.picture} alt={item.title} style={{ width: '80px', borderRadius: '8px' }} />
              </td>
              <td style={tdStyle}>{item.title}</td>
              <td style={tdStyle}>{item.genre}</td>
              <td style={tdStyle}>{item.zone1}</td>
              <td style={tdStyle}>{item.zone2}</td>
              <td style={tdStyle}>{item.zone3}</td>
              <td style={tdStyle}>{item.zone4}</td>
              <td style={tdStyle}>{item.zone5}</td>
             
            </tr>
          ))}
        </tbody>
      </table>


      <button className="back-button" onClick={onBack}>⬅ Back to Zones</button>
    </div>
  );
}

export default ZoneTable;
